/* eslint-disable no-debugger */
/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';

import { format } from 'date-fns';

import {
  PatientCardContainer,
  PatientCardHeader,
  PatientCardHeaderText,
  PatientCardHeaderTextSecond,
  PatientCardInfos,
  PatientCardInfosSpan,
  PatientCardInfosSecond,
  UnblockerButton,
  UnblockerButtonLabel,
} from './styles';

import { Icon, Modal, CodeValidator } from '~/shared/components';
import avatar from '~/assets/images/avatar.png';

function buildShowInfo(cardData) {
  return {
    patientName: cardData.patient?.name ?? null,
    date: cardData.datetime
      ? format(new Date(cardData.datetime), 'dd/MM/yyyy')
      : null,
    doctorArticle: 'Dr(a).',
    doctorName: cardData.doctor?.name ?? null,
    doctorClassCodeType: cardData.doctor?.class_code?.classification ?? null,
    doctorClassCode: cardData.doctor?.class_code?.code ?? null,
    doctorClassOrigin: cardData.doctor?.class_code?.origin ?? null,
  };
}

function PatientInformation({
  documents = null,
  prescriptionData = null,
  postData = null,
  modalIsOpen = false,
  setModalAsOpen = null,
  setExamItems = null,
  validationKey = {},
}) {
  const [showingData, setShowingData] = useState(null);
  useEffect(() => {
    const cardData = prescriptionData || documents;
    if (!cardData) return;

    setExamItems(prescriptionData?.data ?? documents.data);
    setShowingData(buildShowInfo(cardData));
  }, [prescriptionData, documents]);
  return (
    <PatientCardContainer>
      <PatientCardHeader>
        <PatientCardHeaderText>
          <PatientCardInfos>
            Paciente:
            <PatientCardInfosSpan colorDark="true">
              {showingData && showingData.patientName
                ? showingData.patientName
                : '********'}
            </PatientCardInfosSpan>
          </PatientCardInfos>
          <PatientCardInfos>
            Data da solicitação:{' '}
            <PatientCardInfosSpan colorDark="true">
              {showingData && showingData.date
                ? showingData.date
                : '** ** ****'}
            </PatientCardInfosSpan>
          </PatientCardInfos>
        </PatientCardHeaderText>
        <PatientCardHeaderTextSecond>
          <img src={avatar} alt="HIAE" />
          <PatientCardInfosSecond>
            <PatientCardInfos>
              <PatientCardInfosSpan colorDark="true" fontSizeLarger="true">
                {showingData && showingData.doctorArticle}
              </PatientCardInfosSpan>
              {showingData && showingData.doctorName
                ? showingData.doctorName
                : '*******'}
            </PatientCardInfos>
            <PatientCardInfos>
              <PatientCardInfosSpan>
                {showingData ? showingData.doctorClassCodeType : 'CRM'}
              </PatientCardInfosSpan>
              {showingData && showingData.doctorClassCode
                ? showingData.doctorClassCode
                : '******'}
              -
              {showingData && showingData.doctorClassOrigin
                ? showingData.doctorClassOrigin
                : '**'}
            </PatientCardInfos>
          </PatientCardInfosSecond>
        </PatientCardHeaderTextSecond>
      </PatientCardHeader>
      {!prescriptionData && (
        <UnblockerButton
          onClick={() => {
            setModalAsOpen(true);
          }}
        >
          <Icon name="lock" size="20px" />
          <UnblockerButtonLabel>Visualizar dados</UnblockerButtonLabel>
        </UnblockerButton>
      )}

      <Modal
        widthContainer="350px"
        heightContainer="330px"
        isOpen={modalIsOpen}
        onCloseRequest={(event) => {
          event.preventDefault();
          setModalAsOpen(!modalIsOpen);
        }}
      >
        <div>
          {documents && (
            <CodeValidator
              validationKey={validationKey}
              postData={(value) => postData(value)}
              title="Desbloquear"
              width="165px"
              fontSize="16px"
              height="50px"
            />
          )}
        </div>
      </Modal>
    </PatientCardContainer>
  );
}

export default PatientInformation;
